import { createContext, useState } from 'react';

const TableViewContext = createContext({
  isDeploymentView: false,
  deploymentId: null,
  allDeployments: [],
  setIsDeploymentView: (setIsDeploymentView) => { },
  setDeploymentId: (setDeploymentId) => { },
  setAllDeployments: (setAllDeployments) => { }
});

export function TableViewContextProvider(props) {
  const [isDeploymentView, setIsDeploymentView] = useState()
  const [deploymentId, setDeploymentId] = useState()
  const [allDeployments, setAllDeployments] = useState()

  const context = {
    isDeploymentView,
    deploymentId,
    allDeployments,
    setIsDeploymentView,
    setDeploymentId,
    setAllDeployments
  };

  return <TableViewContext.Provider value={context}>
    {props.children}
  </TableViewContext.Provider>
}

export default TableViewContext;
